import React from 'react';
import ReviewResponder from '../components/ReviewResponder';
import ProtectedRoute from '../components/ProtectedRoute';

const ReplyGenerator: React.FC = () => (
  <ProtectedRoute>
    <ReviewResponder />
  </ProtectedRoute>
);

export default ReplyGenerator;
